import { AvatarModule } from 'primeng/avatar';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SplitterModule } from 'primeng/splitter';
import { DialogModule } from 'primeng/dialog';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { MenuModule } from 'primeng/menu';
import { SlideMenuModule } from 'primeng/slidemenu';
import { TreeModule } from 'primeng/tree';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SliderModule } from 'primeng/slider';

const CommonModulesList: any[] = [
  AvatarModule,
  NgScrollbarModule,
  SplitterModule,
  DialogModule,
  NgSelectModule,
  CKEditorModule,
  ButtonModule,
  CheckboxModule,
  AutoCompleteModule,
  TooltipModule,
  OverlayPanelModule,
  DragDropModule,
  RadioButtonModule,
  CalendarModule,
  TableModule,
  AccordionModule,
  NgxPermissionsModule,
  MenuModule,
  SlideMenuModule,
  TreeModule,
  ToastModule,
  ProgressSpinnerModule,
  SliderModule,
];

@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
})
export class LibraryPrimeNgModule {}
